import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import ErrorMessage from 'hb-react/shared/components/ErrorMessage';
import RequiredExplanation from 'hb-react/shared/components/formik/components/RequiredExplanation';

import LoginEmail from './LoginEmail';
import LoginMFA from './LoginMFA';
import LoginSignup from './LoginSignup';
import LoginSocial from './LoginSocial';
import LoginSso from './LoginSso';
import LoginTermsAndPolicy from './LoginTermsAndPolicy';

const LoginForm = ({ currentNetwork, errors, settings }) => {
  const {
    email,
    signup,
    social,
    sso,
    terms_and_policy: termsAndPolicy,
  } = settings;
  const urlParams = new URLSearchParams(window.location.search);
  const origin = urlParams.get('redirect_to');

  const [displayMFA, setDisplayMFA] = useState(null);

  return (
    <>
      {displayMFA ? (
        <LoginMFA displayMFA={displayMFA} />
      ) : (
        <>
          {errors && !!errors.length && (
            <ErrorMessage errors={errors} className="push--bottom" />
          )}
          <Box font="h3-semibold">{I18n.t('web.networks.show.login')}</Box>
          {email.enabled && <RequiredExplanation mt={3} />}
          <LoginSso settings={sso} origin={origin} />
          {sso.enabled && email.enabled && (
            <CustomSeparator className="or-separator" mt={3}>
              <Box as="span" display="inline">
                {I18n.t('actions.or')}
              </Box>
            </CustomSeparator>
          )}
          <LoginEmail
            currentNetwork={currentNetwork}
            settings={email}
            setDisplayMFA={setDisplayMFA}
          />
          {(sso.enabled || email.enabled) && social.enabled && (
            <CustomSeparator className="or-separator" mt={3}>
              <Box as="span" display="inline">
                {I18n.t('actions.or')}
              </Box>
            </CustomSeparator>
          )}
          <LoginSocial settings={social} origin={origin} />
          <LoginSignup settings={signup} />
          <LoginTermsAndPolicy settings={termsAndPolicy} />
        </>
      )}
    </>
  );
};

export default LoginForm;

const CustomSeparator = styled(Box)`
  padding: 12px 0;
  &.or-separator:before,
  &.or-separator:after {
    align-self: center;
    background: #cecece;
    height: 1px;
    transform: initial;
  }
`;
